module.exports = __webpack_public_path__ + "assets/icon-nav-overview-component.7eade276.svg";